//Definicion Controller
import { axiosClient, getToken } from '../../Config/axiosConfig';
import { cliente } from './clientesTypes';
import { iMensaje } from '../../Utilidades/mensaje.interface';

type ClientesQuery = {
	page?: number;
	limit?: number;
	q?: string;
	busqueda?: string;
	sortBy?: string;
	sortDir?: string;
};

class Clientes {
	async list(params: ClientesQuery = {}) {
		await getToken();
		return await axiosClient.get('/clientes', { params });
	}
	async post(data: cliente) {
		await getToken();
		return await axiosClient.post<iMensaje[]>('/clientes', data);
	}
	async delete(id: number) {
		await getToken();
		return await axiosClient.delete<iMensaje[]>(`/clientes/${id}`);
	}
	async update(id: number, data: cliente) {
		await getToken();
		return await axiosClient.put<iMensaje[]>(`/clientes/${id}`, data);
	}
}

export default new Clientes();

export const getClientesBySearch = async (busqueda: string, limit = 20) => {
	await getToken();
	const term = busqueda.trim();
	return await axiosClient.get('/clientes', {
		params: {
			q: term,
			limit,
			sortBy: 'nombre',
			sortDir: 'ASC',
		} as ClientesQuery,
	});
};
export const getClienteById = async (clienteId: number) => {
	await getToken();
	return await axiosClient.get(`/clientes/${clienteId}`);
};
